module.exports = __webpack_public_path__ + "media/images/photo/top/plan/plan5-cb48a1416e9726da2c9ed84417c66bc4.jpg";